export default "__VITE_ASSET__jNsjAOfl__"